import { createContext } from 'react';

const GoogleMapContext = createContext(null);
export default GoogleMapContext;
